export const ROLES = {
  ADMIN: 'admin',
  BASIC: 'basic',
  TENANT_ADMIN: 'tenant_admin',
  TENANT_BASIC: 'tenant_basic',
  TENANT_MANAGER: 'tenant_manager',
  TENANT_ALIURAKOITSIJA: 'tenant_aliurakoitsija',
  TENANT_TECH_ADMIN: 'tenant_tech_admin',
};
